import React, { useState } from "react";
import * as Styled from "./styles";
import { ASSETS } from "../../utils/config";
import { TextView } from "components";
import Icon from "assets/images/settings/insurance.svg";
import styled from "styled-components";
import { colors } from "../../utils";
import CustomTabs from "../CustomTabs";
import { TermsAndConditionsAPI } from "./LegalTabs/TermsAndConditionsAPI";
import { PrivacyPolicyAPI } from "./LegalTabs/PrivacyPolicyAPI";
import { ReferralProgramAPI } from "./LegalTabs/ReferralProgramAPI";
import { FoundingAmbassadorsAPI } from "./LegalTabs/FoundingAmbassadorsAPI";
import { useGetTermsAndConditions } from "../../services/queries";

const Item = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.lightBorder};
`;

export default function Legal() {
  const [tabIndex, setTabIndex] = useState(0);

  // Call the API once in the parent component
  const { data, isLoading, error } = useGetTermsAndConditions();

  const hasReferralTerms = data?.data?.results?.some(
    (item) => item.slug === "referral_terms"
  );
  const hasFATerms = data?.data?.results?.some(
    (item) => item.slug === "fa_terms"
  );

  const tabs = ["Terms & Conditions", "Privacy Policy"];
  const componentsMap = {
    0: (
      <TermsAndConditionsAPI data={data} isLoading={isLoading} error={error} />
    ),
    1: <PrivacyPolicyAPI data={data} isLoading={isLoading} error={error} />,
  };

  let currentTabIndex = 2; // Start index for dynamic tabs

  if (hasReferralTerms) {
    tabs.push("Earnings Program");
    componentsMap[currentTabIndex] = (
      <ReferralProgramAPI data={data} isLoading={isLoading} error={error} />
    );
    currentTabIndex++;
  }

  if (hasFATerms) {
    tabs.push("Founding Ambassador");
    componentsMap[currentTabIndex] = (
      <FoundingAmbassadorsAPI data={data} isLoading={isLoading} error={error} />
    );
    currentTabIndex++;
  }

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);

    const tabContentElement = document.querySelector(".tab-content-container");
    if (tabContentElement) {
      tabContentElement.scrollTop = 0;
    }
  };

  return (
    <Styled.CenterWrapper>
      <Styled.ContentHeader>
        <Styled.HeaderIcon src={ASSETS.Insurance} />
        <TextView variant="title">Terms & Policies</TextView>
      </Styled.ContentHeader>
      <Styled.Content>
        <CustomTabs value={tabIndex} onChange={handleChange} tabs={tabs} />

        <Styled.TabContent className="tab-content-container">
          {componentsMap[tabIndex]}
        </Styled.TabContent>
      </Styled.Content>
    </Styled.CenterWrapper>
  );
}
